import React, { useState } from "react";
import SubwayIntegration from "./views/subway";
import MozrestIntegration from "./views/mozrest";
import QlubIntegration from "./views/qlub/general";
import QlubPatIntegration from "./views/qlub/pat";
import DailySalesSummary from "./views/subwayCSV/dailySalesSummary";
import Products from "./views/subwayCSV/products";
import ProductsCustom from "./views/subwayCSV/productsByDateRange";
import Promotions from "./views/subwayCSV/promotions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";

const Integrations = () => {
  const [mainType, setMainType] = useState("subway");
  const [subwayType, setSubwayType] = useState("weekly");
  const [dailyPusherType, setDailyPusherType] = useState("daily-sales");
  const [expandSubway, setExpandSubway] = useState(true);
  const [qlubType, setQlubType] = useState("qlub");
  const [expandQlub, setExpandQlub] = useState(true);

  return (
    <div className="integrations-container">
      {/* Sidebar */}
      <aside className="integrations-sidebar">
        <div className="sidebar-header">
          <h3>Integrations</h3>
        </div>

        <nav className="sidebar-nav">
          {/* Subway Item */}
          <div className="nav-item">
            <button
              className={`nav-item-header ${mainType === "subway" ? "active" : ""}`}
              onClick={() => {
                setMainType("subway");
                setExpandSubway(!expandSubway);
              }}
            >
              <FontAwesomeIcon
                icon={[
                  "fas",
                  expandSubway && mainType === "subway"
                    ? "chevron-down"
                    : "chevron-right",
                ]}
                className="nav-icon"
              />
              <span>Subway</span>
            </button>

            {/* Subway Sub-items */}
            {mainType === "subway" && expandSubway && (
              <div className="nav-submenu">
                <button
                  className={`nav-subitem ${subwayType === "weekly" ? "active" : ""}`}
                  onClick={() => {
                    setSubwayType("weekly");
                  }}
                >
                  <span className="submenu-icon"></span>
                  Weekly Pusher
                </button>

                <button
                  className={`nav-subitem ${subwayType === "daily" ? "active" : ""}`}
                  onClick={() => {
                    setSubwayType("daily");
                  }}
                >
                  <span className="submenu-icon"></span>
                  Daily Pusher
                </button>

                {/* Daily Pusher Sub-items */}
                {subwayType === "daily" && (
                  <div className="nav-subsubmenu">
                    <button
                      className={`nav-subsubitem ${dailyPusherType === "daily-sales" ? "active" : ""}`}
                      onClick={() => setDailyPusherType("daily-sales")}
                    >
                      Daily Sales Summary
                    </button>
                    <button
                      className={`nav-subsubitem ${dailyPusherType === "products" ? "active" : ""}`}
                      onClick={() => setDailyPusherType("products")}
                    >
                      Products
                    </button>
                    <button
                      className={`nav-subsubitem ${dailyPusherType === "products-custom" ? "active" : ""}`}
                      onClick={() => setDailyPusherType("products-custom")}
                    >
                      Products Custm
                    </button>
                    <button
                      className={`nav-subsubitem ${dailyPusherType === "promotions" ? "active" : ""}`}
                      onClick={() => setDailyPusherType("promotions")}
                    >
                      Promotions
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Mozrest Item */}
          <div className="nav-item">
            <button
              className={`nav-item-header ${mainType === "mozrest" ? "active" : ""}`}
              onClick={() => setMainType("mozrest")}
            >
              <FontAwesomeIcon
                icon={["fas", "chevron-right"]}
                className="nav-icon"
              />
              <span>Mozrest</span>
            </button>
          </div>

          {/* Qlub Item */}
          <div className="nav-item">
            <button
              className={`nav-item-header ${mainType === "qlub" ? "active" : ""}`}
              onClick={() => {
                setMainType("qlub");
                setExpandQlub(!expandQlub);
              }}
            >
              <FontAwesomeIcon
                icon={[
                  "fas",
                  expandQlub && mainType === "qlub"
                    ? "chevron-down"
                    : "chevron-right",
                ]}
                className="nav-icon"
              />
              <span>Qlub</span>
            </button>

            {/* Qlub Sub-items */}
            {mainType === "qlub" && expandQlub && (
              <div className="nav-submenu">
                <button
                  className={`nav-subitem ${qlubType === "qlub" ? "active" : ""}`}
                  onClick={() => setQlubType("qlub")}
                >
                  <span className="submenu-icon"></span>
                  Qlub
                </button>

                <button
                  className={`nav-subitem ${qlubType === "pat" ? "active" : ""}`}
                  onClick={() => setQlubType("pat")}
                >
                  <span className="submenu-icon"></span>
                  Qlub PAT
                </button>
              </div>
            )}
          </div>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="integrations-content">
        {mainType === "subway" && subwayType === "weekly" && (
          <SubwayIntegration />
        )}
        {mainType === "subway" && subwayType === "daily" && (
          <>
            {dailyPusherType === "daily-sales" && <DailySalesSummary />}
            {dailyPusherType === "products" && <Products />}
            {dailyPusherType === "promotions" && <Promotions />}
            {dailyPusherType === "products-custom" && <ProductsCustom />}
          </>
        )}
        {mainType === "mozrest" && <MozrestIntegration />}
        {mainType === "qlub" && qlubType === "qlub" && <QlubIntegration />}
        {mainType === "qlub" && qlubType === "pat" && <QlubPatIntegration />}
      </main>
    </div>
  );
};

export default Integrations;
